"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.migrateBaseField = exports.noopMigrateFunc = exports.migrateMultipleSelectToSingleSelect = exports.migrateTagsFieldToListField = exports.migrateStatusFieldToListField = exports.migrateSingleSelectFieldToMultipleSelectField = void 0;
const fields_logic_registry_1 = require("../field-type-registry/fields-logic-registry");
const color_1 = require("../utils/color");
const utils_1 = require("./utils");
const migration_1 = require("../utils/migration");
function migrateSingleSelectFieldToMultipleSelectField(fieldTo, fieldFrom) {
    var _a;
    const migratedField = migrateBaseField(fieldTo, fieldFrom);
    const controlType = fieldFrom.params.control_type === "radiobutton" ? "checkbox" : "dropdown";
    const displayFormat = fieldFrom.params.display_format === "text_icon"
        ? "colored_pill"
        : fieldFrom.params.display_format;
    const defaultValue = fieldFrom.params.default_value
        ? [fieldFrom.params.default_value]
        : [];
    return {
        ...migratedField,
        params: {
            ...migratedField.params,
            choices: (_a = fieldFrom.params.choices) !== null && _a !== void 0 ? _a : [],
            display_format: displayFormat,
            control_type: controlType,
            required: fieldFrom.params.required,
            default_value: defaultValue,
            help_text: fieldFrom.params.help_text,
            help_text_display_format: fieldFrom.params.help_text_display_format,
        },
    };
}
exports.migrateSingleSelectFieldToMultipleSelectField = migrateSingleSelectFieldToMultipleSelectField;
function migrateStatusFieldToListField(fieldTo, fieldFrom) {
    const migratedField = migrateBaseField(fieldTo, fieldFrom);
    if (!fieldFrom.slug && !(0, utils_1.isDefaultChoicesChanged)(fieldFrom)) {
        return {
            ...migratedField,
            params: {
                ...migratedField.params,
                choices: [],
                default_value: null,
                help_text: "",
                help_text_display_format: "tooltip",
            },
        };
    }
    return migratedField;
}
exports.migrateStatusFieldToListField = migrateStatusFieldToListField;
function migrateTagsFieldToListField(fieldTo, fieldFrom, applicationId) {
    var _a;
    const fieldChoices = (_a = fieldFrom.params.choices) !== null && _a !== void 0 ? _a : [];
    const migratedField = migrateBaseField(fieldTo, fieldFrom);
    const choices = fieldChoices.map((choice, index) => ({
        ...choice,
        color: (0, color_1.getColorByIndex)(index),
        value_color: (0, color_1.getColorByIndex)(index).background,
    }));
    const extraChoices = getExtraChoices(fieldFrom, applicationId, choices.length);
    return {
        ...migratedField,
        params: {
            ...migratedField.params,
            choices: choices === null || choices === void 0 ? void 0 : choices.concat(extraChoices),
            required: fieldFrom.params.required,
            help_text: fieldFrom.params.help_text,
            help_text_display_format: fieldFrom.params.help_text_display_format,
            default_value: getDefaultValue(fieldTo, fieldFrom),
        },
    };
}
exports.migrateTagsFieldToListField = migrateTagsFieldToListField;
function getExtraChoices(appField, applicationId, startFromIdx) {
    var _a;
    const tagsFromChoices = new Set();
    (_a = appField.params.choices) === null || _a === void 0 ? void 0 : _a.forEach((choice) => tagsFromChoices.add(String(choice.value)));
    const extraTags = new Set();
    const fieldLogic = (0, fields_logic_registry_1.getFieldLogic)(appField.field_type);
    const records = fieldLogic.appRecordsService.getApplicationRecords(applicationId);
    records.forEach((record) => {
        const tagsValue = fieldLogic.getFieldValue(appField, record);
        if (tagsValue) {
            tagsValue.forEach((tag) => !tagsFromChoices.has(tag) && extraTags.add(tag));
        }
    });
    return Array.from(extraTags).map((tag, index) => {
        var _a, _b;
        const label = (_b = (_a = fieldLogic.appRecordsService.getTagById(tag)) === null || _a === void 0 ? void 0 : _a.label) !== null && _b !== void 0 ? _b : "";
        const color = (0, color_1.getColorByIndex)(startFromIdx + index);
        const valueColor = (0, color_1.getColorByIndex)(startFromIdx + index).background;
        return {
            value: tag,
            label,
            color,
            value_color: valueColor,
            value_order: startFromIdx + index,
        };
    });
}
function getDefaultValue(fieldTo, fieldFrom) {
    var _a;
    const fromDefaultValue = fieldFrom.params.default_value;
    return fieldTo.field_type === "singleselectfield"
        ? (_a = fromDefaultValue === null || fromDefaultValue === void 0 ? void 0 : fromDefaultValue[0]) !== null && _a !== void 0 ? _a : ""
        : fromDefaultValue !== null && fromDefaultValue !== void 0 ? fromDefaultValue : "";
}
function migrateMultipleSelectToSingleSelect(fieldTo, fieldFrom) {
    var _a, _b, _c, _d;
    const initialField = fieldFrom;
    const migratedField = migrateBaseField(fieldTo, fieldFrom);
    const controlType = fieldFrom.params.control_type === "checkbox" ? "radiobutton" : "dropdown";
    const defaultValue = (_b = (_a = initialField.params.default_value) === null || _a === void 0 ? void 0 : _a[0]) !== null && _b !== void 0 ? _b : "";
    return {
        ...migratedField,
        params: {
            ...migratedField.params,
            choices: (_c = initialField.params.choices) !== null && _c !== void 0 ? _c : [],
            display_format: (_d = initialField.params.display_format) !== null && _d !== void 0 ? _d : "colored_pill",
            control_type: controlType,
            required: initialField.params.required,
            default_value: defaultValue,
            help_text: initialField.params.help_text,
            help_text_display_format: initialField.params.help_text_display_format,
        },
    };
}
exports.migrateMultipleSelectToSingleSelect = migrateMultipleSelectToSingleSelect;
/**
 * Dummy migration function that doesn't make any migration and just returns value
 */
const noopMigrateFunc = (_fieldFrom, _fieldTo, value, _currentValue, _userPreferences) => value;
exports.noopMigrateFunc = noopMigrateFunc;
function migrateBaseField(fieldTo, fieldFrom, _applicationId) {
    const fieldToLogic = (0, fields_logic_registry_1.getFieldLogic)(fieldTo.field_type);
    if (fieldFrom.is_new) {
        fieldTo.slug = fieldFrom.slug;
        fieldTo.is_new = true;
    }
    return {
        ...fieldTo,
        params: {
            ...fieldTo.params,
            help_text: fieldToLogic.params.help_text,
            help_text_display_format: fieldToLogic.params.help_text_display_format,
            ...(0, migration_1.mergeFieldParams)(fieldTo, fieldFrom),
            placeholder: fieldToLogic.params.placeholder,
            default_value: fieldToLogic.params.default_value,
            width: fieldToLogic.params.width,
        },
    };
}
exports.migrateBaseField = migrateBaseField;
